import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {scenariosData} from 'data/scenarios-data';
import {loginUiTexts, gameUiTexts} from 'data/ui-texts';
import {renderMarkdown} from 'helpers/text-helper';
import Button from 'components/ui/button/button';
import QRCode from 'components/ui/qr-code/qr-code';
import './landing-page-group.scss';

const LandingPageGroup = (props) => {
	/* Props */
	const {game, schoolData, scenarioId, resetGameProgress, handleGoToPage, handleLogout, updateBackground} = props;

	/* Page title */
	let title = (game && game.status === 'evaluation' 
		? gameUiTexts.thankYouForPlaying
		: gameUiTexts.welcomeTo
	);



	let startBtnText = gameUiTexts.startGame;
	if (scenarioId === 'game5') {
		startBtnText = gameUiTexts.goToOffice;
	}

	if (
		
		schoolData && 
		game && 
		game.status !== 'evaluation'
	) {
		if ((scenarioId === 'game4' || scenarioId === 'game3')) {
			title = JSON.parse(JSON.stringify(gameUiTexts.welcomeToGame))
				.replace('%game%', scenariosData[scenarioId].title);
		} else if (scenarioId === 'game1' || scenarioId === 'game2' || scenarioId === 'game5') {
			title = JSON.parse(JSON.stringify(gameUiTexts.welcomeToGameWith))
				.replace('%game%', scenariosData[scenarioId].title);
		}
	}

	/* QR url */
	const scenarioData = scenariosData[scenarioId];
	let qrUrl = scenarioData.defaultQrUrl;
	if (schoolData && schoolData.scenarioQrUrls) {
		const scenarioQrUrl = schoolData.scenarioQrUrls.find((s) => {return s.scenarioId === scenarioId;});
		if (scenarioQrUrl && scenarioQrUrl.qrUrl) {
			qrUrl = scenarioQrUrl.qrUrl;
		}
	}
	if (qrUrl.indexOf('http://') === 0) {
		qrUrl = qrUrl.replace('http://', 'https://');
	}
	if (qrUrl.indexOf('https://') !== 0) {
		qrUrl = 'https://' + qrUrl;	
	}
	
	const scenarioUrl = scenarioData.gameUrl ? scenarioData.gameUrl : appConfig.gameUrl + '/' + scenarioData.url;
	const evaluationText = JSON.parse(JSON.stringify(gameUiTexts.qrCodeInfo)).replace('%url%', scenarioUrl);
	
	useEffect(() => {
		// Set background image id
		updateBackground('login', scenarioId);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className={'LandingPageGroup ' + game.status}>
			<div className="LandingPageGroup-welcome"><span>{title}</span></div>
			<div className='LandingPageGroup-logoWrapper'>
				
				{(schoolData && game.status !== 'evaluation') && <div className="LandingPageGroup-schoolName">
					<span>{schoolData.name}</span>
				</div>}
			</div>


			{/* Start game btn */}
			{game.status === 'open' && <div className='LandingPageGroup-startBtn'>
				<Button 
					classes={['blueLight', scenarioId, 'responsive']}
					text={startBtnText}
					onClick={() => {handleGoToPage('game');}}
				/>
			</div>}
				
			{/* Game not begun / game over */}
			{(game.status !== 'open' && game.status !== 'evaluation') &&
				<div className={'LandingPageGroup-gameNotStarted ' + scenarioId} >
					<span>{game.status === 'ready' ? gameUiTexts.gameNotBegun : gameUiTexts.gameOver}</span>
				</div>
			}

			{/* Qr code (if game is evaluation) */}
			{game.status === 'evaluation' && <div className="LandingPageGroup-qrCodeWrap">
				<div className="LandingPageGroup-qrCodeText">
					{renderMarkdown(evaluationText)}
				</div>
				<div className="LandingPageGroup-qrCodeImage">
					<QRCode url={qrUrl} />
				</div>
				<div className={'LandingPageGroup-qrCodeUrl ' + scenarioData.id}>
					<a href={qrUrl} target="_blank" rel="noreferrer">{gameUiTexts.evaluation}</a>
				</div>

			</div>}

			{/* Logout button */}
			<div className="LandingPageGroup-logoutBtn">
				<Button 
					classes={['login', scenarioId]} 
					text={loginUiTexts.logout}
					onClick={() => {handleLogout();}}
				/>
			</div>

			{/* Reset game btn */}
			{(appConfig.env === 'development' || appConfig.env === 'test') && 
				<div className="LandingPageGroup-resetBtn">
					<Button 
						classes={['login', scenarioId]} 
						text={gameUiTexts.resetBtn}
						onClick={() => {resetGameProgress();}}
					/>
				</div>
			}
		</div>
	);
};

LandingPageGroup.propTypes = {
	game: PropTypes.object.isRequired,
	schoolData: PropTypes.object,
	scenarioId: PropTypes.string.isRequired,
	resetGameProgress: PropTypes.func.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	handleLogout: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired
};

export default LandingPageGroup;
